let requestCount = 0;
const maxRequests = 10;
const timeFrame = 60000; // 1 minuto

export const rateLimit = () => {
  requestCount++;
  setTimeout(() => {
    requestCount--;
  }, timeFrame);

  if (requestCount > maxRequests) {
    return false; // Bloqueia a requisição
  }
  return true; // Permite a requisição
};
